import React from "react";
import { Clock, MessageSquareText, Sparkles } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const traits = [
  {
    icon: Clock,
    title: "Szybka komunikacja",
    desc: "Odpisujemy w godzinach, nie w dniach. Bez znikania w trakcie projektu.",
  },
  {
    icon: Sparkles,
    title: "Zaangażowanie w detale",
    desc: "Każdy piksel, każde zdanie i każda animacja ma swoją rolę.",
  },
  {
    icon: MessageSquareText,
    title: "Dopracowanie do końca",
    desc: "Nie kończymy po wdrożeniu — zostajemy do pełnego efektu.",
  },
];

export const About = () => {
  const ref = useReveal();
  return (
    <section
      id="o-nas"
      ref={ref}
      data-testid="about-section"
      className="relative py-24 md:py-32 px-6 md:px-10"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 reveal">
            <span className="text-xs tracking-[0.2em] uppercase text-stormly-cyan font-bold">
              O Stormly
            </span>
            <h2 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl mt-4 leading-[1.05]">
              Cisza przed burzą?{" "}
              <span className="text-stormly-cyan">My jesteśmy tym</span>, co po
              niej.
            </h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed">
              Stormly to mała, zwinna agencja, która buduje strony i sklepy dla
              firm chcących iść do przodu. Premium efekt, bez korpomarży.
            </p>
            <p className="mt-4 text-white/60 leading-relaxed">
              Bez gadania o „synergiach”. Bez fakturowania słów. Konkret,
              kontakt, efekt — w tej kolejności.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#kontakt" className="btn-primary">
                Porozmawiajmy
              </a>
              <a href="#portfolio" className="btn-ghost">
                Zobacz realizacje
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 reveal reveal-delay-2 grid gap-4">
            {traits.map((t, i) => {
              const Icon = t.icon;
              return (
                <div
                  key={t.title}
                  data-testid={`about-trait-${i}`}
                  className="card-glow flex items-start gap-5 bg-[#1F1F38] border border-white/10 rounded-2xl p-6"
                >
                  <div className="h-12 w-12 rounded-xl bg-stormly-cyan/10 border border-stormly-cyan/30 flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-stormly-cyan" />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg mb-1">
                      {t.title}
                    </h3>
                    <p className="text-white/60 text-sm leading-relaxed">
                      {t.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
